<template>
    <div :class="{'absolute': absolute, 'mask': mask, dialog:true }" :style="{marginTop:marginTop,marginLeft:marginLeft}" v-if="index != 2">
      <transition name="fade">
        <div class="load" v-show="index=='0' || msg == 'Cancel'">
          <div class="spinner">
            <i></i>
          </div>
          <div class="load_title">正在加载...</div>
        </div>
      </transition>
      <div class="mistake" v-show="index=='1' && msg != 'Cancel'">
        <div class="word">{{msg}}</div>
        <div v-if="isRefresh" class="re_data_btn" @click.stop="refresh">重新加载</div>
      </div>
    </div>
</template>


<script type="text/ecmascript-6">
  export default{
    props: {
      absolute:{
        type:Boolean,
        default:false,
      },
      mask:{
        type:Boolean,
        default:false,
      },
      isRefresh:{
        type:Boolean,
        default:true,
      },
      index:{
        type:String,
        default:"0"
      },
      msg:{
        type:String,
        default:"暂无数据"
      },
      marginTop:{
        type:String,
        default:'0px'
      },
      marginLeft:{
        type:String,
        default:'0px'
      },

    },
    data(){
      return{
      }
    },
    methods:{
      refresh:function () {
        let self=this;
        self.$emit('comRefresh');
      }
    }
  }
</script>

<style scoped lang="scss" type="text/scss">
   $width:20px;
   $height:20px;
   $left:10px;
   .absolute{
     position:absolute;
     top:0px;
     width:100%;
     height: 100%;
   }
  .mask {
    background-color: rgba(0, 0, 0, 0.2);
  }
  .dialog{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #aaa;
    .load{
      display: flex;
      align-items: center;
      .spinner {
        z-index:999;
        font-size: 30px;
        width: $width;
        height: $height;
        border-radius: 50%;
        box-shadow: inset 0 0 0 3px rgba(58, 168, 237, 0.2);
        position: relative;
        display: inline-block;
        transform:translateX(-$width/2);
        i {
          position: absolute;
          clip: rect(0, $width, $height, $left);
          width: $width;
          height:$height;
          animation: spinner-circle-clipper 1s ease-in-out infinite;
          &:after {
            position: absolute;
            clip: rect(0, $width, $height, $left);
            width: $width;
            height: $height;
            content: '';
            animation: spinner-circle 1s ease-in-out infinite;
            border-radius: 50%;
            box-shadow: inset 0 0 0 .1em #3aa8ed;
          }
        }
      }
      .load_title{
        display: inline-block;
        font-size: 14px;
        color: #aaa;
      }
    }
    .mistake{
      z-index: 999;
      display: flex;
      align-items: center;
      justify-content: space-around;
      /*flex-direction:column;*/
      .word{
        text-align: center;
      }
      .re_data_btn{
        /*margin-top: 10px;*/
        padding: 6px 15px;
        border-radius: 8px;
        font-size: 14px;
        border: 1px solid rgb(16, 45, 89);
        &:hover{
          color: #3aa8ed;
          background:rgb(16, 45, 89) ;
          cursor: pointer;
        }
      }
    }
    .fade-enter-active, .fade-leave-active {
      transition: opacity  .5s ,transform .5s;
      transform:scale(1);
    }
    .fade-enter, .fade-leave-to  {
      opacity: 0;
      transform:scale(0);

    }
  }
  @keyframes spinner-circle-clipper {
    from {
      transform: rotate(0deg);
    }

    to{
      transform: rotate(180deg);
    }
  }
  @keyframes spinner-circle {
    from {
      transform: rotate(-180deg);
    }

    to {
      transform: rotate(180deg);
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/common/loading/loading.vue